"use client";

import { COMPANY_INFO } from "@/info/company";
import { Home, Search } from "lucide-react";
import Link from "next/link";

export function UnitNotFound() {
	return (
		<div className="min-h-screen bg-gray-50 flex flex-col">
			<main className="flex-1 flex items-center justify-center px-4 py-16">
				<div className="text-center max-w-md mx-auto">
					{/* Icon */}
					<div className="text-6xl mb-6">🏠</div>

					{/* Title */}
					<h1 className="text-3xl font-bold text-gray-900 mb-4">Unit Not Found</h1>

					{/* Description */}
					<p className="text-gray-600 mb-8 leading-relaxed">
						The property unit you&apos;re looking for doesn&apos;t exist or may have been removed. This could happen if
						the listing has expired or the URL is incorrect.
					</p>

					{/* Action Links */}
					<div className="space-y-4">
						<Link
							href="/bengaluru/flats-for-sale"
							className="flex items-center justify-center w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
						>
							<Search className="w-4 h-4 mr-2" />
							Browse Available Properties
						</Link>

						<Link
							href="/"
							className="flex items-center justify-center w-full px-6 py-3 border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium rounded-lg transition-colors"
						>
							<Home className="w-4 h-4 mr-2" />
							Go to Homepage
						</Link>
					</div>

					{/* Help Section */}
					<div className="mt-12 p-4 bg-blue-50 rounded-lg border border-blue-200">
						<h3 className="font-semibold text-blue-900 mb-2">Need Help?</h3>
						<p className="text-sm text-blue-700 mb-3">
							If you believe this is an error or need assistance finding a property:
						</p>
						<div className="space-y-2 text-sm text-blue-600">
							<p>
								• Contact our support team at{" "}
								<a href={`mailto:${COMPANY_INFO.contact.email.primary}`}>{COMPANY_INFO.contact.email.primary}</a>
							</p>
							<p>• Try searching with different criteria</p>
							<p>• Check if the URL is correct</p>
						</div>
					</div>
				</div>
			</main>
		</div>
	);
}
